<template lang="pug">
  .s-cont
    .s-card
      .background-color(:style="`background: ${hex};`")
        .s-header
          h3.title {{ title }}
        span.amount.bold(v-if="!notAmount") {{ amount | currency }}
        span.amount.bold(v-else) -
</template>

<script>
export default {
  name: 'simple-stat-card',
  data: () => ({}),
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    amount: {
      type: Number,
      default: 0
    },
    notAmount: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    hex: {
      type: String,
      default: '#ffffff'
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.s-cont {
  height: 100px;
  border-radius: 10px;
  box-sizing: content-box;
  position: relative;
  user-select: none;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: 0.2s transform ease-in-out;
}
.s-card {
  height: 100%;
  border-radius: 10px;
}
.s-header {
  display: flex;
  align-items: center;
}
.title {
  z-index: 1;
  font-weight: light;
  line-height: 1.5rem;
  color: black;
}
.amount {
  font-size: 1.5rem;
  color: black;
}
.bold {
  font-weight: bold;
}
.background-color {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 18px 15px;
  color: white;
}
button {
  border: 0 !important;
  height: 24px !important;
  padding: 0 !important;
}
.view-btn {
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.1s all ease-in-out;
  margin: 0 0 0 auto;
}
.view-btn:hover {
  border-radius: 5px;
  background: rgba($color: #000000, $alpha: 0.2)
}
</style>
